import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./ContentGroup.module.scss";
import { FixDetails } from "../fix-details";

export interface ContentGroupProps extends PropsWithChildren {
  title: string;
  variant: "details" | "column";
  className?: string;
  slot?: string;
}

export interface ContentTitleProps {
  title: string;
}

export const ContentGroup: React.FC<ContentGroupProps> = ({ title, variant, className, children, slot }) => {
  if (variant === "details") {
    return (
      <FixDetails className={classNames(styles.group, styles.details, className)} summary={title}>
        {children}
      </FixDetails>
    );
  }

  return (
    <div className={classNames(styles.group, styles.column, className)} slot={slot}>
      <ContentTitle title={title} />
      {children}
    </div>
  );
};

export const ContentTitle: React.FC<ContentTitleProps> = ({ title }) => {
  return <div className={styles.title}>{title}</div>;
};
